let instance;
const makeSingleton = (initial) => {
    let value = initial;
    return {
        getValue: () => value,
        setValue: (valueToSet) => (value = valueToSet),
    };
};
const getSelectedScopeId = (initial) => {
    if (!instance) {
        instance = makeSingleton(initial);
        return instance;
    }
    if (initial) {
        throw Error('Selected Scope Id is already initialized');
    }
    return instance;
};
export { getSelectedScopeId };
